import React from "react";
import {
  FolderOpenRounded,
  SchemaRounded,
  HubRounded,
} from "@mui/icons-material";
import { Box, Tabs, Tab, Divider, Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { GradientIconLight } from "../../../components/GradientIcon";
import { useThemeSettings } from "../../../theme/ThemeSettingsProvider";

const useStyles = makeStyles()((theme) => ({
  gradientText: {
    background: theme.palette.light,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  customTabs: {
    minHeight: 36,
    marginTop: 2,
    "& .MuiTabs-indicator": {
      height: 4,
      borderRadius: "50px 50px 0px 0px",
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.primary.main : "#9C27B0",
    },
    "& .MuiTab-root": {
      minHeight: 36,
      paddingTop: 6,
      paddingBottom: 6,
    },
    "& .MuiTabs-flexContainer": {
      minHeight: 36,
      paddingTop: 6,
      paddingBottom: 4,
    },
    "& .MuiTab-root.Mui-selected": {
      color:
        theme.palette.mode === "dark" ? theme.palette.primary.main : "#9C27B0",
    },
  },
}));

export const tabs = [
  {
    label: "File Explorer",
    value: "file_explorer",
    icon: FolderOpenRounded,
  },
  {
    label: "P&ID Explorer",
    value: "pid_explorer",
    icon: SchemaRounded,
    isComingSoon: true,
  },
  {
    label: "Knowledge Graph",
    value: "knowledge_graph",
    icon: HubRounded,
    isComingSoon: true,
  },
];

function DataExplorerTabs({ currentTab, onTabChange }) {
  const { classes } = useStyles();
  const { mode } = useThemeSettings();
  return (
    <Box>
      <Tabs
        centered
        value={currentTab}
        onChange={onTabChange}
        className={classes.customTabs}
        aria-label="data explorer tabs">
        {tabs.map((tab) => {
          const isSelected = tab.value === currentTab;
          return (
            <Tab
              key={tab.value}
              sx={{ minHeight: 52 }}
              label={
                <Box display={"flex"} alignItems={"center"}>
                  <span className={isSelected ? classes.gradientText : ""}>
                    {tab.label}
                  </span>
                  {tab.isComingSoon && (
                    <Chip
                      disabled
                      label="Coming Soon"
                      size="small"
                      sx={{ fontWeight: 500, borderRadius: 1, ml: 1 }}
                    />
                  )}
                </Box>
              }
              disabled={tab.isComingSoon}
              value={tab.value}
              icon={
                isSelected ? (
                  mode === "dark" ? (
                    <tab.icon
                      sx={{
                        marginRight: 1,
                        color: (theme) => theme.palette.text.primary,
                      }}
                    />
                  ) : (
                    <GradientIconLight
                      Icon={tab.icon}
                      sx={{ marginRight: 1 }}
                    />
                  )
                ) : (
                  <tab.icon />
                )
              }
              iconPosition="start"
            />
          );
        })}
      </Tabs>
      <Divider />
    </Box>
  );
}

export default DataExplorerTabs;
